/**
 * Base class for all actions.
 */
class Action {
  type;
  config;
  log = [];
  meta = {};
  #guid;
  initialized = false;

  dependencies = {
    execute: [],
    undo: [],
    hydrateMeta: []
  }

  constructor(config = {}) {
    this.config = config;
  }

  get guid() {
    return this.#guid;
  }

  set guid(value) {
    this.#guid = value;
  }

  async initialize() {
    if (this.initialized) return;
    try {
      await this.hydrateMeta();
      this.initialized = true;
    } catch (e) {
      console.error(this.logPrefix, 'Failed to hydrate meta -', e.message);
    }
  }

  checkDependencies(type) {
    let missingDependencies = this.dependencies[type].filter(helper => !Stencil.Helpers[helper]);
    if (missingDependencies.length > 0) {
      throw new Error(`Missing required dependencies for '${type}': ${missingDependencies.join(', ')}`);
    }
  }

  execute(data) {
    this.checkDependencies("execute");
  }

  undo(data) {
    this.checkDependencies("undo");
  }

  explainAction() {
    throw new Error("Method 'explainAction()' must be implemented.");
  }

  explainUndo() {
    throw new Error("Method 'explainUndo()' must be implemented.");
  }

  hydrateMeta() {
    this.checkDependencies("hydrateMeta");
  }

  addLog(result = true, message, icon = "", mode = "execute") {
    this.log.push({ time: Date.now(), type: this.type, result: icon != "" ? icon : result ? "✅" : "❌", message });
  }

  get logPrefix() {
    return `\x1b[30;41;1m[Action/${this.type}]`;
  }
}

export default Action;